
import { IPropertyMapping, IPropertyUpdate } from '@/typings/import';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DeductiblePaymentSelect from '@/components/DeductiblePaymentSelect.vue';
import DeductibleTypeSelect from '@/components/DeductibleTypeSelect.vue';
import QuotaTimeSelect from '@/components/QuotaTimeSelect.vue';
import TripDestinationsSelect from '@/components/TripDestinationsSelect.vue';
import TripDirectionsSelect from '@/components/TripDirectionsSelect.vue';
import DestinationSelector from '@/components/Passenger/components/DestinationSelector.vue';
import Destination from '../Passenger/models/Destination';
import PassengerMapping from './models/passenger/PassengerMapping';

interface IPropertyUpdateComponent {
  component: string;
  name: string;
  props: object;
  input: (value: any) => void;
}

@Component({
  components: {
    DeductiblePaymentSelect,
    DeductibleTypeSelect,
    QuotaTimeSelect,
    TripDestinationsSelect,
    TripDirectionsSelect,
    DestinationSelector,
  },
})
export default class PropertyUpdateRow extends Vue {
  private propertyUpdate: IPropertyUpdate<any> | null = null;
  private showEdit: boolean = false; 

  @Prop({ required: true }) private value: IPropertyUpdate<any>;
  @Watch('value', { immediate: true }) onValueChanged() {
    this.propertyUpdate = this.value;
  }

  get organizationId(): string | null {
    return this.$route.params.organizationId ?? null;
  }
  
  get overrideInputs(): IPropertyUpdateComponent[] {
    return [
      { 
        component: 'VTextField', 
        name: 'v-text-field', 
        props: {}, 
        input: (value) => this.setValue(value) 
      },
      { 
        component: 'DeductiblePaymentSelect', 
        name: 'deductible-payment-select', 
        props: {}, 
        input: (value) => this.setValue(value) 
      },
      { 
        component: 'DeductibleTypeSelect', 
        name: 'deductible-type-select', 
        props: {}, 
        input: (value) => this.setValue(value) 
      },
      { 
        component: 'QuotaTimeSelect', 
        name: 'quota-time-select', 
        props: {}, 
        input: (value) => this.setValue(value) 
      },
      { 
        component: 'TripDestinationsSelect', 
        name: 'trip-destinations-select', 
        props: { }, 
        input: (value) => this.setValue(value) 
      },
      { 
        component: 'TripDirectionsSelect', 
        name: 'trip-directions-select', 
        props: {}, 
        input: (value) => this.setValue(value) 
      },
      { 
        component: 'DestinationSelector', 
        name: 'destination-selector', 
        props: { organizationId: this.organizationId }, 
        input: (value) => this.setDestinationValue(value) 
      },
    ];
  }

  get overrideInput(): IPropertyUpdateComponent {
    switch (this.propertyUpdate.propertyName) {
      case 'quotaTime':
        return this.overrideInputs.find(oi => oi.name === 'quota-time-select');
      case 'tripDestinations':
        return this.overrideInputs.find(oi => oi.name === 'trip-destinations-select');
      case 'tripDirection':
        return this.overrideInputs.find(oi => oi.name === 'trip-directions-select');
      case 'deductibleType':
        return this.overrideInputs.find(oi => oi.name === 'deductible-type-select');
      case 'deductiblePayment':
        return this.overrideInputs.find(oi => oi.name === 'deductible-payment-select');
      case PassengerMapping.PROPERTY_MAPPING_DESTINATION:
      case PassengerMapping.PROPERTY_MAPPING_SECONDARY_DESTINATION:
        return this.overrideInputs.find(oi => oi.name === 'destination-selector');
      default:
        return this.overrideInputs.find(oi => oi.name === 'v-text-field');
    }
  }

  openOverrideEdit() {
    this.showEdit = true;
  }

  setValue(value: any) {
    this.propertyUpdate.overrideValue = value;
  }

  setDestinationValue(value: any) {
    const destinations = this.$store.state.destination.destinations as Destination[];
    const destination = destinations.find(d => d.id === value);
    this.propertyUpdate.overrideValue = destination.alias as any;
  }

}
